import { PhosphorMusicNotes } from "components/Atoms/PhosphorIcon";
import React from "react";
import { getShowHeaderTexts } from "shared/utils/purpleHeaderUtils";
import { EventHeaderLayout } from "./EventHeaderLayout";

interface ShowHeaderProps {
  show: server.dto.Show
}

export const ShowHeader = ({ show }: ShowHeaderProps) => {
  const texts = getShowHeaderTexts(show);

  return <EventHeaderLayout
    icon={<PhosphorMusicNotes iconColor="white" iconSize="large" />}
    tourName={texts.tourName}
    title={texts.title}
    subtitle={texts.subtitle}
    location={texts.location}
    dateTime={show.dateTime}
    attendees={show.attendees.map(a => a.name.fullName)}
    artist={show.artist}
    locked={show.isLocked}
    notValidated={show.validationStatus === "notValidatedInputByExternal" || show.validationStatus === "notValidatedInputByWebform"}
  />;
};
